<template>
  <div class="flex w-full items-center">
    <div class="flex gap-1">
      <!-- Previous Button -->
      <Button variant="paper-primary" size="sm" @click="goToPage(pageNum - 1)">
        <template #icon>
          <Icon name="ArrowLeft" class="w-4 h-4" />
        </template>
      </Button>

      <!-- Page Numbers  -->
      <div class="flex gap-1">
        <button
          v-for="page in pagesToShow"
          :key="page"
          @click="goToPage(page)"
          :disabled="page === '...'"
          class="flex min-h-9 min-w-9 items-center justify-center rounded-full text-base border border-filter-outline text-strongest"
          :class="getPageButtonClass(page)"
        >
          <p class="font-inter">
            {{ page }}
          </p>
        </button>
      </div>

      <!-- Next Button -->
      <Button variant="paper-primary" size="sm" @click="goToPage(pageNum + 1)">
        <template #icon>
          <Icon name="ArrowRight" class="w-4 h-4" />
        </template>
      </Button>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { Icon, Button } from "@/components";

const props = defineProps({
  totalItems: {
    type: Number,
    required: true,
  },
  pageSize: {
    type: Number,
    default: 10,
  },
  pageNum: {
    type: Number,
    default: 1,
  },
});

const emit = defineEmits(["change-page"]);

const totalPages = computed(() => {
  return Math.ceil(props.totalItems / props.pageSize);
});

const pagesToShow = computed(() => {
  const pages = [];
  const total = totalPages.value;
  const current = props.pageNum;

  if (total <= 7) {
    for (let i = 1; i <= total; i++) {
      pages.push(i);
    }
    return pages;
  }

  if (current <= 4) {
    for (let i = 1; i <= 5; i++) {
      pages.push(i);
    }
    pages.push("...");
    pages.push(total);
    return pages;
  }

  if (current >= total - 3) {
    pages.push(1);
    pages.push("...");
    for (let i = total - 4; i <= total; i++) {
      pages.push(i);
    }
    return pages;
  }

  pages.push(1);
  pages.push("...");
  pages.push(current - 1);
  pages.push(current);
  pages.push(current + 1);
  pages.push("...");
  pages.push(total);
  return pages;
});

function goToPage(page) {
  if (page === "...") return;
  if (page < 1 || page > totalPages.value) return;
  emit("change-page", page);
}

function getPageButtonClass(page) {
  if (page === "...") {
    return "cursor-default";
  }
  if (page === props.pageNum) {
    return "bg-filter-bg font-bold";
  }
  return "font-medium";
}
</script>
